export const DIFFICULTY = {
  EASY: {
    name: 'Easy',
    speed: 3,
    obstacleRate: 2000,
    lightningChance: 0,
    gap: 180,
    gameTime: 60,
    scoreMultiplier: 1
  },
  MEDIUM: {
    name: 'Medium',
    speed: 5,
    obstacleRate: 1300,
    lightningChance: 0.2,
    gap: 140,
    gameTime: 45,
    scoreMultiplier: 1.5
  },
  HARD: {
    name: 'Hard',
    speed: 7,
    obstacleRate: 900,
    lightningChance: 0.4,
    gap: 100,
    gameTime: 30,
    scoreMultiplier: 2
  }
};

